module.exports = __webpack_public_path__ + "static/img/login_two.03723b59.png";